// src/components/UserCompositionChart.js
import React from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";

const UserCompositionChart = () => {
  const data = {
    labels: ["Women", "Men"],
    datasets: [
      {
        data: [35, 65],
        backgroundColor: ["#6a0dad", "#2dd4bf"],
        hoverBackgroundColor: ["#6a0dad", "#2dd4bf"],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.label}: ${tooltipItem.raw}%`;
          },
        },
      },
    },
  };

  return (
    <div className="w-full h-full p-2">
      <h3 className="text-[20.3px] font-bold font-sans mb-3">
        Users Composition
      </h3>
      <div className="flex justify-center items-center w-full h-[250px]">
        <Doughnut data={data} options={options} />
      </div>
      <p className="text-center text-[#949494] my-2">500 users in total</p>
    </div>
  );
};

export default UserCompositionChart;
